import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import theme from '@cubeyou-team/hx-theme';
import {
  Box,
  Button,
  Col,
  Icon,
  InfoLabel,
  ListGroup,
  Row,
  Text,
  Tooltip,
} from '@cubeyou-team/hx-react-components';

import { QueryBadge } from '../../../../../query-badge';
import { StyledSavedQuery, StyledText } from './SavedQuery.styles';

const StyledSavedQueryIconContainer = styled.div<{ size: string }>`
  width: ${props => props.theme.avatar_size[props.size]};
  height: ${props => props.theme.avatar_size[props.size]};
  border-radius: ${props => props.theme.border_radius.circle};
  border: 1px solid ${props => props.theme.colors.dark_lighter};
  overflow: hidden;
  cursor: default;
  background-color: ${props => props.theme.colors.violet};
`;

const StyledSavedQueryIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SavedQuery: FC<any> = ({ item, tabIndex, onSavedQuerySelected }) => {
  const { label, taxonomy, type, source } = item;

  const getCategoriesRows = taxonomy => {
    return taxonomy.map(
      (cat, index) =>
        index > 0 && (
          <Text key={index + cat} variant="light" size="xsmall" align="center">
            {cat}
          </Text>
        )
    );
  };

  const itemType = useMemo(() => {
    if (type === 'membership') {
      return 'conversation';
    }

    return type;
  }, [type]);

  const taxonomyLabel = useMemo(() => {
    return taxonomy[0] || '';
  }, [taxonomy]);

  return (
    <Box>
      <React.Fragment>
        <StyledSavedQuery
          tabIndex={tabIndex}
          key={item.id}
          data-item-id={item.id}
          isClickable={type === 'membership'}
        >
          <Row
            gutter="small"
            halign="between"
            valign="middle"
            onClick={() => {
              type === 'membership' && onSavedQuerySelected(item, false);
            }}
          >
            <Col span={12}>
              <Row valign="middle">
                <Col span="auto">
                  <StyledSavedQueryIconContainer size="medium">
                    <StyledSavedQueryIcon>
                      <Icon
                        icon={type !== 'membership' ? 'heart' : 'conversation'}
                        variant="light"
                      />
                    </StyledSavedQueryIcon>
                  </StyledSavedQueryIconContainer>
                </Col>
                <Col style={{ width: '20%' }}>
                  <Row>
                    <Col>
                      <Row>
                        <Col span="auto" style={{ maxWidth: '100%' }}>
                          <Text title={label} size="xbody" weight="bold">
                            {label}
                          </Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          span="auto"
                          style={{ padding: theme.spacing.xxsmall }}
                        >
                          <InfoLabel label={itemType} />
                        </Col>
                        {source && (
                          <Col
                            span="auto"
                            style={{ padding: theme.spacing.xxsmall }}
                          >
                            <QueryBadge source={source} />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col
                          span="auto"
                          style={{
                            maxWidth: taxonomy.length > 1 ? '80%' : '100%',
                          }}
                        >
                          <StyledText>
                            <Text as="span" size="xsmall" title={taxonomy[0]}>
                              {taxonomyLabel}
                            </Text>
                          </StyledText>
                        </Col>
                        {taxonomy.length > 1 && (
                          <Col>
                            <Tooltip
                              content={getCategoriesRows(taxonomy)}
                              position="bottom"
                            >
                              <InfoLabel
                                label={`+${taxonomy.length - 1}`}
                                variant="pending"
                              />
                            </Tooltip>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {type !== 'membership' && (
                  <Col>
                    <Box pY="medium" pX="medium">
                      <ListGroup
                        items={[
                          <Button
                            key="0"
                            size="small"
                            onClick={() => onSavedQuerySelected(item, false)}
                          >
                            Single item
                          </Button>,
                          <Button
                            key="1"
                            size="small"
                            variant="outlined"
                            onClick={() => onSavedQuerySelected(item, true)}
                          >
                            Expand
                          </Button>,
                        ]}
                        direction="row"
                      />
                    </Box>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </StyledSavedQuery>
      </React.Fragment>
    </Box>
  );
};

export default SavedQuery;
